import { provideWidgetClass } from "scrivito"
import { Alignment } from "shared/lib/layout/Alignment"
import { AppActionType } from "shared/types/AppAction"
import { IconPlacement } from "shared/types/Button"
import { IconSize } from "shared/types/Icon"
import { ButtonVariant } from "shared/ui/buttons/Button"
import { EDITOR_ICONS } from "shared/ui/icon/EditorIcons"

export const ButtonWidget = provideWidgetClass("ButtonWidget", {
  attributes: {
    alignment: ["enum", { values: Object.values(Alignment) }],
    target: "link",
    title: "string",
    action: ["enum", { values: Object.values(AppActionType) }],
    variant: ["enum", { values: Object.values(ButtonVariant) }],
    icon: ["enum", { values: EDITOR_ICONS }],
    type: ["enum", { values: ["link", "button", "scrolltarget"] }],
    scrollTargetId: "string",
    isDanger: "boolean",
    isBold: "boolean",
    iconPlacement: ["enum", { values: Object.values(IconPlacement) }],
    iconSize: ["enum", { values: Object.values(IconSize) }]
  }
})
